import { AuthContext } from "contexts/AuthContext";
import { useContext, useEffect } from "react";
import { useRoutes } from "react-router-dom";
import routes from "./routes";

export default function Routes() {
  // return useRoutes([MainRoutes, LoginRoutes]);
  const { authenticated } = useContext(AuthContext);

  const routing = useRoutes(routes(authenticated));
  return <>{routing}</>;
}
